import { createContext } from 'react';
import { CardContextType } from '../types';

export const BasicCardContext = createContext<CardContextType | undefined>(
	undefined,
);
